import { afterSixItems, beforeSixItems } from '@/mocks/homeData';

const COLUMNS = [
  {
    key: 'before',
    label: '六点前的瓜',
    desc: '午后到 17:59 收进池的零散线索',
    icon: 'ri-sun-cloudy-line',
    items: beforeSixItems,
    accent: 'text-secondary-700',
    dot: 'bg-secondary-400',
    chip: 'bg-secondary-100 text-secondary-800',
  },
  {
    key: 'after',
    label: '六点刚出的事',
    desc: '18:00 之后陆续冒出来的回应',
    icon: 'ri-moon-clear-line',
    items: afterSixItems,
    accent: 'text-primary-600',
    dot: 'bg-primary-500',
    chip: 'bg-primary-100 text-primary-700',
  },
];

export default function SixSplitSection() {
  return (
    <section className="w-full border-t border-background-200 bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1360px] px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
              Before & After
            </span>
            <h2 className="mt-2 font-heading text-xl font-black tracking-tight text-foreground-950 md:text-3xl">
              以 18:00 为分界线看今天
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              左边是六点前攒下的，右边是六点后冒出来的。两边对着读，哪些是旧料回锅、哪些是新进展一眼就看出来。
            </p>
          </div>
          <span className="flex shrink-0 items-center gap-2 rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-700">
            <i className="ri-calendar-check-line text-sm text-primary-500" />
            2026.09.10 当日对照
          </span>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {COLUMNS.map((col) => (
            <div
              key={col.key}
              className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="flex items-center gap-3 border-b border-background-200 bg-background-100 px-4 py-3.5 md:px-5">
                <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50">
                  <i className={`${col.icon} text-lg ${col.accent}`} />
                </span>
                <div>
                  <p className="font-heading text-base font-black text-foreground-950">
                    {col.label}
                  </p>
                  <p className="text-xs text-foreground-500">{col.desc}</p>
                </div>
                <span className={`ml-auto rounded-sm px-2 py-0.5 text-[11px] font-semibold ${col.chip}`}>
                  {col.items.length} 条
                </span>
              </div>
              <ul className="divide-y divide-background-100">
                {col.items.map((item) => (
                  <li
                    key={item.time}
                    className="group flex cursor-pointer items-start gap-3 px-4 py-3.5 transition-colors hover:bg-background-100 md:px-5"
                  >
                    <span className="flex w-11 shrink-0 items-center gap-1.5 pt-0.5">
                      <span className={`h-1.5 w-1.5 rounded-full ${col.dot}`} />
                      <span className="font-heading text-xs font-bold tabular-nums text-foreground-800">
                        {item.time}
                      </span>
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                        {item.title}
                      </span>
                      <span className="mt-1 block text-[11px] text-foreground-500">
                        来源：{item.source}
                      </span>
                    </span>
                    <i className="ri-arrow-right-s-line mt-0.5 text-base text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500" />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}